module.exports = __webpack_public_path__ + "static/CardOfDarkness1-8419567dc095707640fa1ab01af24c86.png";